import { useNavigate } from "react-router";
import { To } from "react-router-dom";
import { useEffectOnce } from "@lib-shared/hooks";

const Redirect = ({ to }: { to: To }) => {
    const navigate = useNavigate();

    useEffectOnce(() => navigate(to));

    return null;
}

export default Redirect;
